/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: CA
 *| (C) Copyright IBM Corp. 2016, 2021
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define([
	'../../lib/@waca/core-client/js/core-client/ui/core/Class'
], function(Class) {
	'use strict';
	var RemoveDataSourceAction = null;
	RemoveDataSourceAction = Class.extend({
		/**
		 * Determine when we enable/disable the menu item
		 */
		isItemDisabled: function(options) {
			try{
				let dataSourceId = options.target.activeObject.dataSource.getId();
				let dashboardApi = options.glassContext.appController.getCurrentContentView().getDashboardApi();
				let dataSourcesApi = dashboardApi.getFeature('DataSources');
				let dataSourceApi = dataSourcesApi.getDataSource(dataSourceId);
				return dataSourceApi.isDataSourceUsed();
			}catch(error){
				options.glassContext.getCoreSvc('.Logger').error('could not decide to enable/disable the menu items', error);
				return true;
			}
		},

		/**
		 * Default action handler
		 */
		onSelectItem: function(options) {
			try{
				let dataSourceId = options.target.activeObject.dataSource.getId();
				let dashboardApi = options.glassContext.appController.getCurrentContentView().getDashboardApi();
				let dataSourcesApi = dashboardApi.getFeature('DataSources');
				dataSourcesApi.removeDataSource(dataSourceId);
			}catch(error){
				options.glassContext.getCoreSvc('.Logger').error('could not remove the datasource', error);
			}
		}
	});

	return RemoveDataSourceAction;
});
